import React from 'react';
import { Trophy, TrendingUp, Zap } from 'lucide-react';
export function TopLists() {
  const lists = [{
    title: 'Top RPGs 2026',
    icon: Trophy,
    color: 'text-pinnacle-gold',
    games: [{
      name: 'Veilstorm Chronicles',
      score: 94
    }, {
      name: 'Noctis Wanderer',
      score: 91
    }, {
      name: 'Ironmere Legends',
      score: 85
    }, {
      name: 'Duskfall Protocol',
      score: 83
    }]
  }, {
    title: 'Best Indies',
    icon: Zap,
    color: 'text-pinnacle-cyan',
    games: [{
      name: "Luminara's Descent",
      score: 87
    }, {
      name: 'Thornhaven Siege',
      score: 76
    }, {
      name: 'Emberfrost Trails',
      score: 79
    }, {
      name: 'Starweave Nexus',
      score: 81
    }]
  }, {
    title: 'Rising Stars',
    icon: TrendingUp,
    color: 'text-pinnacle-green',
    games: [{
      name: 'Ashborne Requiem',
      score: 88
    }, {
      name: 'Ecliptic Frontier',
      score: 82
    }, {
      name: 'Grimtide Odyssey',
      score: 78
    }, {
      name: "Solara's Vigil",
      score: 80
    }]
  }];
  return <section className="py-24 bg-[#0f0f16]" data-id="element-192">
      <div className="container mx-auto px-4" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-194">
          Curated Collections
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-195">
          {lists.map((list, idx) => <div key={idx} className="bg-pinnacle-card border border-pinnacle-border rounded-xl p-6 hover:border-gray-600 transition-colors" data-id="element-196">
              <div className="flex items-center gap-3 mb-6" data-id="element-197">
                <list.icon className={`w-6 h-6 ${list.color}`} data-id="element-198" />
                <h3 className="text-xl font-bold text-white" data-id="element-199">{list.title}</h3>
              </div>

              <div className="space-y-4" data-id="element-200">
                {list.games.map((game, i) => <div key={i} className="flex items-center justify-between group cursor-pointer" data-id="element-201">
                    <div className="flex items-center gap-3" data-id="element-202">
                      <span className="text-gray-600 font-mono text-sm w-4" data-id="element-203">
                        {i + 1}
                      </span>
                      <span className="text-gray-300 group-hover:text-white transition-colors" data-id="element-204">
                        {game.name}
                      </span>
                    </div>
                    <div className={`px-2 py-1 rounded text-xs font-bold bg-gray-800 ${game.score >= 90 ? 'text-pinnacle-green' : game.score >= 80 ? 'text-pinnacle-cyan' : 'text-pinnacle-orange'}`} data-id="element-205">
                      {game.score}
                    </div>
                  </div>)}
              </div>

              <button className="w-full mt-6 py-2 text-sm text-gray-400 hover:text-white border border-dashed border-gray-700 hover:border-gray-500 rounded transition-all" data-id="element-206">
                View Full List
              </button>
            </div>)}
        </div>
      </div>
    </section>;
}